angular.module('controllers').controller('marketingCampaignController', ['$scope', '$rootScope', '$controller', '$http', 'Crud', '$mdDialog', '$route', '$routeParams', '$location',
	function ($scope, $rootScope, $controller, $http, Crud, $mdDialog, $route, $routeParams, $location) {
		$rootScope.path = '/marketing-campaign';
		$scope.path = $rootScope.path;
		$rootScope.modelName = 'marketing-campaign';
		$scope.pathTemplate = 'marketing/marketingcampaigns';
		$scope.title = 'Campanii de marketing';

		angular.extend(this, $controller('crudController', {$scope: $scope}));

		//$scope.minDate = new Date();
		//$scope.maxDate = new Date();
		var current_init_date = new Date();
		current_init_date.setHours(0, 0, 0, 0);
		$scope.search.dateFrom = current_init_date;

		$scope.sortType = 'marketing_campaign_start';
		$scope.defaultItem = 10;
        $rootScope.typeId = 'id';
		$scope.search.order = 'asc';
		$scope.classAction = 'td-big';
		$scope.columns = {
			//'id':{'label':'Detalii', 'filter':0, 'filterType':'input'},
			//'client_phone':{'label':'Telefon client', 'filter':1, 'filterType':'input'},
			'marketing_campaign_title':{'label':'Titlu campanie', 'filter':1, 'filterType':'input'},
			'marketing_campaign_start':{'label':'Start campanie', 'filter':1, 'filterType':'input'},
			'marketing_campaign_end':{'label':'End campanie', 'filter':1, 'filterType':'input'},
      'marketing_campaign_times':{'label':'Nr. aplicari', 'filter':1, 'filterType':'input'},
      'marketing_campaign_status':{'label':'Status campanie', 'filter':1, 'filterType':'select'},
			'status':{'label':'Status', 'filter':1, 'filterType':'select'}
		};

		$scope.columns.status.options = [
			{'id':'', 'value' : ''},
			{'id':1, 'value' : 'true'},
			{'id':0, 'value' : 'false'}
		];

		$scope.columns.marketing_campaign_status.options = [
			{'id':'', 'value' : ''},
			{'id':0, 'value' : 'in curs'},
			{'id':1, 'value' : 'inchisa'}
		];
    $scope.additionals['marketing_campaign_status'] = $scope.columns.marketing_campaign_status.options;

		$scope.additionals['status_string'] = JSON.stringify($scope.columns.status.options);
		$scope.additionals['marketing_campaign_status_string'] = JSON.stringify($scope.columns.marketing_campaign_status.options);
	
		$scope.additionals['content_type'] = 'form-urlencoded';

		/* get dependent fields */
		/*$scope.getDependedFields = function () {
			Crud.getDependedFields($scope.path)
				.success(function (data) {
					$scope.additionals['marketings'] = data.marketings;

					/!*if (!angular.isUndefined($scope.columns.shipping_method_name)) {
						$scope.columns.shipping_method_name.options = [{id: '', value: ''}];
						angular.forEach(data.shippingMethods, function (item, key) {
							$scope.columns.shipping_method_name.options.push({
								id: item.shipping_method_name,
								value: item.shipping_method_name
							});
						});
					}*!/

				});
		}*/

		/* close field */
		$scope.additionals['closeField'] = function (paramName, paramId, model, key) {
			if (!angular.isUndefined(key)) {
				model[key][paramName] = '';
				if (!angular.isUndefined(paramId)) {
					model[key][paramId] = '';
				}
			} else {
				model[paramName] = '';
				if (!angular.isUndefined(paramId)) {
					model[paramId] = '';
				}
			}

		}

        $scope.additionals['checkAllClients'] = function () {
            $scope.modelData.clients = [];
            var no = 0; $scope.additionals['modelDataClient'].clients = {};
            if($scope.additionals['modelDataClient'].checkAllClient == true){
                angular.forEach($scope.additionals['clientsForMarketing'], function (item, index) {
                    $scope.modelData.clients[no] = item['client_id'];
                    no++;
                    $scope.additionals['modelDataClient'].clients[item['client_id']] = true;
                });
            }
        }

        $scope.additionals['modelDataClient'] = {};
        $scope.additionals['checkClient'] = function () {
            $scope.modelData.clients = [];
            var no = 0;
            angular.forEach($scope.additionals['modelDataClient'].clients, function (item, index) {
                if(item == true){
                    $scope.modelData.clients[no] = index;
                    no++;
                }
            });
        }

        $scope.additionals['searchClient'] = {};
        $scope.additionals['searchClient'].order = 'asc';
        $scope.additionals['searchClients'] = function (offset, per_page) {
            $scope.additionals['clientsForMarketing'] = [];
            $scope.additionals['searchClientsForMarketing'](offset, per_page);
        }

        $scope.additionals['searchClientsForMarketing'] = function (offset, per_page) {

            if (angular.isUndefined(per_page) || per_page == 'undefined') {
                per_page = $scope.defaultItem;
            }
            $scope.additionals['buttonDisabledPagination'] = true;
            $scope.rangeClients = [];
            if (angular.isUndefined($scope.no_pagesClients)) {
                $scope.no_pagesClients = 1;
            }
            $scope.isLoadingPaginationClients = true;
            $scope.$watch('no_pagesClients', function (item) {
                item = $scope.no_pagesClients;
            }, true);

            $scope.additionals['lastClientsForMarketing'] = 0;
            var post = $scope.additionals['searchClient'];
            post['route'] = 'searchClientsForMarketing';
            Crud.post('form-urlencoded', post, $scope.path + '/searchClientsForMarketing?page=' + offset + '&per_page=' + per_page)
                .success(function (data) {
                    if (!angular.isUndefined(data.invalid)) {
                        $scope.additionals['invalid'] = data.invalid;
                    } else {
                        //$scope.additionals['clientsForMarketing'] = data.data;
                        if(data.data.length > 0) {
                            angular.forEach(data.data, function (item, index) {
                                $scope.additionals['clientsForMarketing'].push(item);
                            });
                        } else {
                            $scope.additionals['lastClientsForMarketing'] = 1;
                        }
                    }
                    //$scope.additionals['searchClient'] = {};
                    $scope.errors = {};
                    $scope.isLoading = false;
                    $scope.additionals['buttonDisabledPagination'] = false;

                    $scope.stopClients = data.next_page_url;
                    $scope.fromClients = data.from;
                    $scope.toClients = data.to;
                    $scope.totalClients = data.total;
                    $scope.no_pagesClients = Math.ceil(data.total / data.per_page);

                    if (per_page == 0) {
                        $scope.rangeClients = [{}];
                    } else {
                        for (var i = 0; i < $scope.no_pagesClients; i++) {
                            $scope.rangeClients[i] = i;
                        }
                    }
                    $scope.additionals['modelsClients'] = {};
                    $scope.additionals['modelsClients'].per_page = data.per_page;
                    $scope.additionals['modelsClients'].current_page = data.current_page;

                    $scope.isLoadingPaginationClients = false;
                })
                .error(function (data) {
                    $scope.isLoading = false;
                    $scope.errors = data.errors;
                    $scope.additionals['buttonDisabled'] = false;
                    if(data == null) {
                        $rootScope.checkNetworkConnection();
                    }
                });


        }

        $scope.additionals['getClientsForMarketing'] = function (marketingCampaignId) {
            var post = {};
            post['route'] = 'getClientsForMarketing';
            post['id'] = marketingCampaignId;
            Crud.post('form-urlencoded', post, $scope.path + '/getClientsForMarketing')
                .success(function (data) {
                    if (!angular.isUndefined(data.invalid)) {
                        $scope.additionals['invalid'] = data.invalid;
                    } else {
                        $scope.additionals['clientsForMarketing'] = data;
                        $scope.modelData.clients = data.map(function (item, index) {
                            return item.client_id;
                        });
                        $scope.additionals['modelDataClient'] = {};
                        $scope.additionals['modelDataClient'].clients = [];
                        angular.forEach(data, function (item, index) {
                            $scope.additionals['modelDataClient'].clients[item['client_id']] = true;
                        });
                    }
                    $scope.errors = {};
                    $scope.isLoading = false;
                    $scope.additionals['buttonDisabled'] = false;
                })
                .error(function (data) {
                    $scope.isLoading = false;
                    $scope.errors = data.errors;
                    $scope.additionals['buttonDisabled'] = false;
                    if(data == null) {
                        $rootScope.checkNetworkConnection();
                    }
                });


        }

        $scope.additionals['getExcludedClientsForMarketing'] = function () {
            var post = {};
            post['route'] = 'getExcludedClientsForMarketing';
            Crud.post('form-urlencoded', post, $scope.path + '/getExcludedClientsForMarketing')
                .success(function (data) {
                    if (!angular.isUndefined(data.invalid)) {
                        $scope.additionals['invalid'] = data.invalid;
                    } else {
                        $scope.additionals['clientsForMarketing'] = data;
                        $scope.modelData.clients = data.map(function (item, index) {
                            return item.client_id;
                        });
                        $scope.additionals['modelDataClient'] = {};
                        $scope.additionals['modelDataClient'].clients = [];
                        angular.forEach(data, function (item, index) {
                            $scope.additionals['modelDataClient'].clients[item['client_id']] = true;
                        });
                    }
                    $scope.errors = {};
                    $scope.isLoading = false;
                    $scope.additionals['buttonDisabled'] = false;
                })
                .error(function (data) {
                    $scope.isLoading = false;
                    $scope.errors = data.errors;
                    $scope.additionals['buttonDisabled'] = false;
                    if(data == null) {
                        $rootScope.checkNetworkConnection();
                    }
                });


        }

        $scope.additionals['cancelSearchClients'] = function (ev, path) {
            $scope.additionals['searchClient'] = {};

            angular.element(document.querySelector('.expand-collapse-content')).slideToggle('200',function() {
                angular.element(document.querySelector('#collapse i')).toggleClass('fa-minus fa-plus');
            });
            angular.element(document.querySelector('mdp-date-picker .md-input-has-value')).removeClass('md-input-has-value');
            angular.element(document.querySelector('mdp-date-picker .md-input-invalid')).removeClass('md-input-invalid');
            angular.element(document.querySelector('mdp-date-picker .md-input-has-value')).removeClass('md-input-has-value');
            angular.element(document.querySelector('mdp-date-picker .md-input-invalid')).removeClass('md-input-invalid');
            var form = document.getElementById('search-client-form');
            form.reset();

            $timeout($scope.removeDate, 500);

        }

        $scope.additionals['function'] = function(ev, data) {
			$scope.additionals['selectedItemClientPhone'] = '';
			$scope.additionals['selectedItemClientPhoneSearch'] = '';
            $scope.additionals['modelDataClient'] = {};
            $scope.additionals['clientsForMarketing'] = [];

			if($scope.action == 'store' || $scope.action == 'update') {
				if (!angular.isUndefined(data.marketing_campaign_start)) {

					if (data.marketing_campaign_start != null) {
						data.marketing_campaign_start_date = new Date(data.marketing_campaign_start);

						var dateStart = data.marketing_campaign_start.split(' ');
						data.marketing_campaign_start_time = new Date(moment().format('D MMM, YYYY') + ' ' + dateStart[1]);
					}
				} else {
					data.marketing_campaign_start_date = current_init_date;
				}
				if (!angular.isUndefined(data.marketing_campaign_end)) {

					if (data.marketing_campaign_end != null) {
						data.marketing_campaign_end_date = new Date(data.marketing_campaign_end);

						var dateEnd = data.marketing_campaign_end.split(' ');
						data.marketing_campaign_end_time = new Date(moment().format('D MMM, YYYY') + ' ' + dateEnd[1]);
					}
				}
			}

            if($scope.action == 'update') {
                $scope.additionals['getClientsForMarketing'](data.id);
                $scope.additionals['lastClientsForMarketing'] = 1;
            }

			if($scope.action == 'updatemultiple') {
				$scope.additionals['selectedItemClientPhoneMultiple'] = [];

				angular.forEach(data, function (item, index) {
					if (!angular.isUndefined(item.marketing_campaign_start)) {

						if (item.marketing_campaign_start != null) {
							item.marketing_campaign_start_date = new Date(item.marketing_campaign_start);

							var dateStart = item.marketing_campaign_start.split(' ');
							item.marketing_campaign_start_time = new Date(moment().format('D MMM, YYYY') + ' ' + dateStart[1]);
						}
					} else {
						item.marketing_campaign_start_date = current_init_date;
					}
					if (!angular.isUndefined(item.marketing_campaign_end)) {

						if (item.marketing_campaign_end != null) {
							item.marketing_campaign_end_date = new Date(item.marketing_campaign_end);

							var dateEnd = item.marketing_campaign_end.split(' ');
							item.marketing_campaign_end_time = new Date(moment().format('D MMM, YYYY') + ' ' + dateEnd[1]);
						}
					}


				});
			}
		}

		$scope.additionals['functionResult'] = function(ev, data) {

		}

		/* close marketing campaign */
		$scope.closeCampaignModel = function (ev, path, modelId, modelIndex) {
			$scope.additionals['invalid'] = '';
			$scope.modelData = {};
			$mdDialog.show({
				controller: DialogController,
				templateUrl: 'closeCampaignDialog.tmpl.html',
				parent: angular.element(document.body),
				targetEvent: ev,
				clickOutsideToClose: true,
				locals: {path: $scope.path, modelId: modelId, modelIndex: modelIndex, models:$scope.models, additionals: $scope.additionals}
			}).then();

			DialogController.$inject = ['$scope', '$mdDialog', 'path', 'modelId', 'modelIndex', 'models', 'additionals'];
			function DialogController($scope, $mdDialog, path, modelId, modelIndex, models, additionals) {
				$scope.path = path;
				$scope.cancel = function () {
					$mdDialog.cancel();
				};
				$scope.additionals = additionals;
				$scope.models = models;

				/* close campaign */
				$scope.closeCampaign = function () {
					$scope.additionals['buttonDisabled'] = true;
					$scope.isLoading = true;
					var post = {};
					post['route'] = 'closeCampaign';
					post['id'] = modelId;
					Crud.post('form-urlencoded', post, $scope.path + '/closeCampaign')
						.success(function (data) {

							if (!angular.isUndefined($scope.models)) {
								$scope.models[modelIndex]['marketing_campaign_status'] = 1;
							}
							$scope.errors = [];
							$mdDialog.cancel();
							$scope.additionals['buttonDisabled'] = false;

						}).error(function (data) {
							$scope.errors = data.errors;
							$mdDialog.cancel();
							$scope.additionals['buttonDisabled'] = false;
						});

				};
			}
		};

		/* close date time field */
		$scope.additionals['closeTime'] = function (ev, field, key) {
			if(ev.keyCode == 46) {
				if (angular.isUndefined(key)) {
					if (field == 'end_time') {
						$scope.modelData.marketing_campaign_end_time = undefined;
					}
					if (field == 'start_time') {
						$scope.modelData.marketing_campaign_start_time = undefined;
					}
				} else {
					if (field == 'end_time') {
						$scope.modelsData[key].marketing_campaign_end_time = undefined;
					}
					if (field == 'start_time') {
						$scope.modelsData[key].marketing_campaign_start_time = undefined;
					}
				}
			}
		}

        /* add clients */
        $scope.addClients = function (ev, path, modelId) {
            $scope.additionals['showSearchClient'] = 1;
            $scope.additionals['clientsForMarketing'] = [];
            $scope.additionals['modelDataClient'] = {};
            $scope.additionals['getClientsForMarketing'](modelId);
            $scope.additionals['lastClientsForMarketing'] = 1;

            if($scope.mode_action == 'page') {
                $scope.controlSH = true;
                $scope.action = 'addclients';
                $scope.actionLabel = 'Adaugare clienti';
                $scope.errors = {};
                $scope.additionals['invalid'] = '';
                angular.element(document.querySelector('.fill-height')).animate({ scrollTop: 250 }, 'slow');

                $scope.cancel = function () {
                    $scope.additionals['modelDataClient'] = {};
                    $scope.errors = {};
                    $scope.controlSH = false;
                };
                $scope.addClientsModel = function () {
                    $scope.additionals['buttonDisabled'] = true;
                    $scope.isLoading = true;

                    var post = {};
                    post['route'] = 'addClients';
                    post['id'] = modelId;
                    post['clients'] = $scope.modelData.clients;

                    Crud.post('form-urlencoded', post, $scope.path + '/addClients')
                        .success(function (data) {
                            if (!angular.isUndefined(data.invalid)) {
                                $scope.additionals['invalid'] = data.invalid;
                            } else {
                            }
                            $scope.additionals['modelDataClient'] = {};
                            $scope.errors = {};
                            $scope.isLoading = false;
                            $scope.controlSH = false;
                            $scope.additionals['buttonDisabled'] = false;
                        })
                        .error(function (data) {
                            $scope.isLoading = false;
                            $scope.errors = data.errors;
                            $scope.additionals['buttonDisabled'] = false;
                            if(data == null) {
                                $rootScope.checkNetworkConnection();
                            }
                        });
                };
            }

            if($scope.mode_action == 'dialog') {
                $scope.additionals['invalid'] = '';
                $scope.errors = {};
                $scope.action = 'addclients';

                $mdDialog.show({
                    controller: DialogController,
                    templateUrl: 'addClientsDialog.tmpl.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    locals: {
                        pathTemplate: $scope.pathTemplate,
                        additionals: $scope.additionals,
                        action: $scope.action,
                        model: $scope.modelData
                    }
                }).then(function () {

                });
                DialogController.$inject = ['$scope', '$mdDialog', 'pathTemplate', 'additionals', 'action', 'model'];
                function DialogController($scope, $mdDialog, pathTemplate, additionals, action, model) {
                    $scope.pathTemplate = pathTemplate;
                    $scope.additionals = additionals;
                    $scope.action = action;
                    $scope.modelData = model;

                    $scope.cancel = function () {
                        $mdDialog.cancel();
                    };

                    $scope.addClientsModel = function () {
                        $scope.additionals['buttonDisabled'] = true;
                        $scope.isLoading = true;

                        var post = {};
                        post['route'] = 'addClients';
                        post['id'] = modelId;
                        post['clients'] = $scope.modelData.clients;

                        Crud.post('form-urlencoded', post, path + '/addClients')
                            .success(function (data) {
                                if (!angular.isUndefined(data.invalid)) {
                                    $scope.additionals['invalid'] = data.invalid;
                                } else {

                                }
                                $scope.isLoading = false;
                                $mdDialog.hide();
                                $scope.additionals['buttonDisabled'] = false;
                            })
                            .error(function (data) {
                                $scope.isLoading = false;
                                $scope.errors = data.errors;
                                $scope.additionals['buttonDisabled'] = false;
                                if(data == null) {
                                    $rootScope.checkNetworkConnection();
                                }
                            });
                    };

                }
            }

        };

        /* exclude clients */
        $scope.excludeClients = function (ev, path, modelId) {
            $scope.additionals['showSearchClient'] = 1;
            $scope.additionals['clientsForMarketing'] = [];
            $scope.additionals['modelDataClient'] = {};
            $scope.additionals['getExcludedClientsForMarketing']();
            $scope.additionals['lastClientsForMarketing'] = 1;

            if($scope.mode_action == 'page') {
                $scope.controlSH = true;
                $scope.action = 'excludeclients';
                $scope.actionLabel = 'Excludere clienti';
                $scope.errors = {};
                $scope.additionals['invalid'] = '';
                angular.element(document.querySelector('.fill-height')).animate({ scrollTop: 250 }, 'slow');

                $scope.cancel = function () {
                    $scope.additionals['modelDataClient'] = {};
                    $scope.errors = {};
                    $scope.controlSH = false;
                };
                $scope.excludeClientsModel = function () {
                    $scope.additionals['buttonDisabled'] = true;
                    $scope.isLoading = true;

                    var post = {};
                    post['route'] = 'excludeClients';
                    post['clients'] = $scope.modelData.clients;

                    Crud.post('form-urlencoded', post, $scope.path + '/excludeClients')
                        .success(function (data) {
                            if (!angular.isUndefined(data.invalid)) {
                                $scope.additionals['invalid'] = data.invalid;
                            } else {
                            }
                            $scope.additionals['modelDataClient'] = {};
                            $scope.errors = {};
                            $scope.isLoading = false;
                            $scope.controlSH = false;
                            $scope.additionals['buttonDisabled'] = false;
                        })
                        .error(function (data) {
                            $scope.isLoading = false;
                            $scope.errors = data.errors;
                            $scope.additionals['buttonDisabled'] = false;
                            if(data == null) {
                                $rootScope.checkNetworkConnection();
                            }
                        });
                };
            }

            if($scope.mode_action == 'dialog') {
                $scope.additionals['invalid'] = '';
                $scope.errors = {};
                $scope.action = 'excludeclients';

                $mdDialog.show({
                    controller: DialogController,
                    templateUrl: 'excludeClientsDialog.tmpl.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    locals: {
                        pathTemplate: $scope.pathTemplate,
                        additionals: $scope.additionals,
                        action: $scope.action,
                        model: $scope.modelData
                    }
                }).then(function () {

                });
                DialogController.$inject = ['$scope', '$mdDialog', 'pathTemplate', 'additionals', 'action', 'model'];
                function DialogController($scope, $mdDialog, pathTemplate, additionals, action, model) {
                    $scope.pathTemplate = pathTemplate;
                    $scope.additionals = additionals;
                    $scope.action = action;
                    $scope.modelData = model;

                    $scope.cancel = function () {
                        $mdDialog.cancel();
                    };

                    $scope.addClientsModel = function () {
                        $scope.additionals['buttonDisabled'] = true;
                        $scope.isLoading = true;

                        var post = {};
                        post['route'] = 'addClients';
                        post['clients'] = $scope.modelData.clients;

                        Crud.post('form-urlencoded', post, path + '/excludeClients')
                            .success(function (data) {
                                if (!angular.isUndefined(data.invalid)) {
                                    $scope.additionals['invalid'] = data.invalid;
                                } else {

                                }
                                $scope.isLoading = false;
                                $mdDialog.hide();
                                $scope.additionals['buttonDisabled'] = false;
                            })
                            .error(function (data) {
                                $scope.isLoading = false;
                                $scope.errors = data.errors;
                                $scope.additionals['buttonDisabled'] = false;
                                if(data == null) {
                                    $rootScope.checkNetworkConnection();
                                }
                            });
                    };

                }
            }

        };

        /* send sms */
        $scope.sendSms = function (ev, path, modelId) {
            $scope.ok = 0;
            if($scope.mode_action == 'page') {
                $scope.controlSH = true;
                $scope.action = 'sendsms';
                $scope.actionLabel = 'Trimitere Sms';
                $scope.errors = {};
                $scope.additionals['invalid'] = '';
                angular.element(document.querySelector('.fill-height')).animate({ scrollTop: 250 }, 'slow');

                $scope.cancel = function () {
                    $scope.additionals['modelDataClient'] = {};
                    $scope.errors = {};
                    $scope.controlSH = false;
                };

                var post = {};
                post['route'] = 'sendSms';
                post['id'] = modelId;
                Crud.post('form-urlencoded', post, $scope.path + '/sendSms')
                    .success(function (data) {
                        if (!angular.isUndefined(data.invalid)) {
                            $scope.additionals['invalid'] = data.invalid;
                        } else {
                            $scope.ok = 1;
                            if (!angular.isUndefined(data.currentModel)) {
                                if (!angular.isUndefined($scope.models)) {
                                    $scope.getElement($scope.models, data.currentModel);
                                }
                                if (!angular.isUndefined($scope.modelData)) {
                                    $scope.modelData = data.currentModel;
                                }
                            } else {
                                if (!angular.isUndefined($scope.models)) {
                                    $scope.getElement($scope.models, currentModel);
                                }
                                if (!angular.isUndefined($scope.modelData)) {
                                    $scope.modelData = currentModel;
                                }
                            }

                        }
                        $scope.errors = {};
                        $scope.isLoadingSendSms = false;
                        $scope.additionals['buttonDisabled'] = false;
                    })
                    .error(function (data) {
                        $scope.isLoading = false;
                        $scope.errors = data.errors;
                        $scope.additionals['buttonDisabled'] = false;
                        if(data == null) {
                            $rootScope.checkNetworkConnection();
                        }
                    });
            }

            if($scope.mode_action == 'dialog') {
                $scope.additionals['invalid'] = '';
                $scope.errors = {};

                $mdDialog.show({
                    controller: DialogController,
                    templateUrl: 'sendSmsDialog.tmpl.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    locals: {
                        pathTemplate: $scope.pathTemplate,
                        additionals: $scope.additionals,
                        action: $scope.action,
                        model: $scope.modelData,
                        models: $scope.models
                    }
                }).then(function () {

                });
                DialogController.$inject = ['$scope', '$mdDialog', 'pathTemplate', 'additionals', 'action', 'model', 'models'];
                function DialogController($scope, $mdDialog, pathTemplate, additionals, action, model, models) {
                    $scope.pathTemplate = pathTemplate;
                    $scope.additionals = additionals;
                    $scope.action = action;
                    $scope.modelData = model;
                    $scope.models = models;

                    $scope.cancel = function () {
                        $mdDialog.cancel();
                    };

                    var post = {};
                    post['route'] = 'sendSms';
                    post['id'] = modelId;
                    Crud.post('form-urlencoded', post, path + '/sendSms')
                        .success(function (data) {
                            if (!angular.isUndefined(data.invalid)) {
                                $scope.additionals['invalid'] = data.invalid;
                            } else {
                                $scope.ok = 1;
                                if (!angular.isUndefined(data.currentModel)) {
                                    if (angular.isUndefined($scope.additionals['invalid']) || $scope.additionals['invalid'] == '') {
                                        if (!angular.isUndefined($scope.models) && !angular.isUndefined($scope.models)) {
                                            if(!angular.isUndefined(data.currentModel)) {
                                                var position = $scope.models.map(function (e) {
                                                    return e[$rootScope.typeId];
                                                }).indexOf(data.currentModel[$rootScope.typeId]);
                                                if(position >= 0) {
                                                    $scope.models[position] = data.currentModel;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                            $scope.errors = {};
                            $scope.isLoadingSendSms = false;
                            $scope.additionals['buttonDisabled'] = false;
                        })
                        .error(function (data) {
                            $scope.isLoading = false;
                            $scope.errors = data.errors;
                            $scope.additionals['buttonDisabled'] = false;
                            if(data == null) {
                                $rootScope.checkNetworkConnection();
                            }
                        });

                }
            }

        };

        /* export clients */
        $scope.exportDataCsvClients = function (models, columns) {
            $scope.exportModels = [];
            angular.forEach(models, function (item, index) {
                var object = {};
                angular.forEach($scope[columns], function (itemColumns, keyColumns) {
                    if (item[keyColumns] instanceof Array) {
                        object[keyColumns] = '';
                    } else {
                        object[keyColumns] = '\n' + item[keyColumns];
                    }
                    $scope.exportModels[index] = object;
                });
            });
            return $scope.exportModels;
        }
        $scope.exportHeaderClients = function (columns) {
            $scope.exportColumns = [];
            angular.forEach(columns, function (item, index) {
                $scope.exportColumns.push(item.label);
            });
            return $scope.exportColumns;
        };

        $scope.exportClients = function (ev, path, modelId) {
            $scope.columnsClients = {
                'client_name':{'label':'Nume client', 'filter':1, 'filterType':'input'},
                'client_phone':{'label':'Telefon client', 'filter':1, 'filterType':'input'},
            };
            if( $scope.mode_action == 'page') {
                $scope.controlSH = true;
                $scope.action = 'exportclients';
                $scope.actionLabel = 'Exportare clienti';
                $scope.errors = {};
                $scope.additionals['invalid'] = '';
                angular.element(document.querySelector('.fill-height')).animate({scrollTop: 250}, 'slow');

                $scope.cancel = function () {
                    $scope.errors = {};
                    $scope.controlSH = false;
                };

                var post = {};
                post['route'] = 'exportClients';
                post['id'] = modelId;
                Crud.post('form-urlencoded', post, $scope.path + '/exportClients')
                    .success(function (data) {
                        if (!angular.isUndefined(data.invalid)) {
                            $scope.additionals['invalid'] = data.invalid;
                        } else {
                            $scope.additionals['exportClients'] = data;
                        }
                        $scope.errors = {};
                        $scope.isLoadingSendSms = false;
                        $scope.additionals['buttonDisabled'] = false;
                    })
                    .error(function (data) {
                        $scope.isLoading = false;
                        $scope.errors = data.errors;
                        $scope.additionals['buttonDisabled'] = false;
                        if (data == null) {
                            $rootScope.checkNetworkConnection();
                        }
                    });
            }

        };

	}]
)
